<template>
  <div>
    <v-img
      style="max-height: 300px"
      contain
      class="mx-auto"
      src="@/assets/amalay-print.png"
    ></v-img>
    <div
      style="max-width: 200px"
      class="d-flex mx-auto justify-center mt-5 mb-2"
    >
      <v-btn
        href="https://www.ubereats.com/mx/store/amalay-coffee-%26-market/YztX1CN6WjKySXzreV8dNQ?srsltid=AfmBOorm_kzsTEDAvcwFsbNBxFC8GBkZrrdST8FVYg1MylMpsJ4sOgX-"
        target="_blank"
        class="overline"
        dark
        color="#ac939e"
        >Ubereats</v-btn
      >
      <v-btn
        href="https://www.rappi.com.mx/restaurantes/1930030014-amalay-coffee-y-market"
        target="_blank"
        class="overline ml-5"
        dark
        color="#939eac"
        style="min-width: 103px"
        >Rappi</v-btn
      >
    </div>
    <v-container class="d-flex flex-column justify-center">
      <v-btn
        :to="{ name: 'menu', params: { id: item.slug } }"
        outlined
        color="white"
        v-for="item in menus"
        :key="item.key"
        class="mx-auto my-3 overline pa-6"
        style="max-width: 280px; min-width: 280px"
      >
        {{ item.name }}
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "HomeView",
  data() {
    return {};
  },
  computed: {
    ...mapState("menu", ["menus"]),
  },
};
</script>
